import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import areAllPropertiesNonEmpty from 'src/compass/shared/util/areAllPropertiesNonEmpty';
import { ICasMultiRowTable } from 'src/compass/shared/components/CasMultiRow/CasMultiRowTable';

import CasAsOfMultiRowTable from './CasAsOfMultiRowTable';

interface ICasAsOfMultiRowWithErrorDisplay extends ICasMultiRowTable {
  triggerValidationList?: string[];
}

export default function CasAsOfMultiRowWithErrorDisplay({
  name,
  triggerValidationList = [],
  ...rest
}: ICasAsOfMultiRowWithErrorDisplay) {
  const { trigger } = useFormContext();

  const triggeredData = useWatch({ name: triggerValidationList });

  useEffect(() => {
    if (triggeredData[0] && areAllPropertiesNonEmpty(triggeredData[0])) trigger(name);
  }, [name, triggeredData, trigger]);

  return <CasAsOfMultiRowTable {...rest} name={name} />;
}
